module.exports = __webpack_public_path__ + "build/assets/STIXTwoText-Italic-fc4345b191afff5ebb2329a00cc02923.woff2";